import React from 'react';

const Nomatch = () => {
    return (
        <div className="error404">
            404 NOT FOUND
            页面跑了哦
        </div>
    );
};

export default Nomatch;